module.exports = __webpack_public_path__ + "static/gm-36-7ab6eccb0be2cf257816cf20b4db941d.jpg";